import React, { Component } from 'react';
import { Link } from "react-router-dom";
import NslMailAPI from '../NslMailAPI.js';
import {Section} from '../Common.js';

class ForgotPassword extends Component {
    state = {
        email: "",
        message: "",
        isSubmitting: false,
        submitted: false
    };

    async componentDidMount() {
        this.API = new NslMailAPI(null);
    }

    async handleSubmit(e) {
        e.preventDefault();
        
        if (!this.state.email) {
            this.setState({ message: "Please enter your email address." });
            return;
        }

        this.setState({ isSubmitting: true, message: "" });

        try {
            let result = await this.API.forgotPassword(this.state.email);
            this.setState({ 
                submitted: true, 
                message: result.message,
                isSubmitting: false 
            });
        } catch (error) {
            this.setState({ 
                message: error.message,
                isSubmitting: false 
            });
        }
    }
    handleSubmit = this.handleSubmit.bind(this);

    render() {
        return (
            <Section name="Forgot Password">
                {!this.state.submitted ? (
                    <div>
                        <p style={{marginBottom: "20px", lineHeight: "1.5em"}}>
                            Enter your email address and we'll send you a link to reset your password.
                        </p>
                        
                        <form onSubmit={this.handleSubmit}>
                            <table style={{margin: "0 auto"}}>
                                <tbody>
                                    <tr>
                                        <td width="120"><label>Email Address:</label></td>
                                        <td>
                                            <input 
                                                value={this.state.email} 
                                                type="email" 
                                                size="30"
                                                style={{padding: "4px", border: "1px solid #89AACD"}}
                                                onChange={(e) => {this.setState({email: e.target.value})}}
                                                disabled={this.state.isSubmitting}
                                                placeholder="your.email@example.com"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" align="center">
                                            <br/>
                                            <input 
                                                type="submit" 
                                                value={this.state.isSubmitting ? "Sending..." : "Send Reset Link"} 
                                                className="button" 
                                                disabled={this.state.isSubmitting}
                                                style={{cursor: this.state.isSubmitting ? "wait" : "pointer"}}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                        
                        {this.state.message && (
                            <div style={{
                                marginTop: "15px", 
                                padding: "10px", 
                                backgroundColor: "#ffebee", 
                                border: "1px solid #f44336", 
                                borderRadius: "4px",
                                color: "#c62828"
                            }}>
                                {this.state.message}
                            </div>
                        )}
                        
                        <div style={{marginTop: "20px", textAlign: "center"}}>
                            <Link to="/" style={{color: "#294081", textDecoration: "none"}}>
                                ← Back to Home
                            </Link>
                        </div>
                    </div>
                ) : (
                    <div style={{textAlign: "center"}}>
                        <div style={{
                            marginBottom: "20px", 
                            padding: "15px", 
                            backgroundColor: "#e8f5e8", 
                            border: "1px solid #4caf50", 
                            borderRadius: "4px",
                            color: "#2e7d32"
                        }}>
                            <strong>✓ Reset link sent!</strong><br/>
                            {this.state.message}
                        </div>
                        
                        <p style={{marginBottom: "20px", lineHeight: "1.5em"}}>
                            Check your email for instructions on how to reset your password. 
                            The reset link will expire after use for security.
                        </p>
                        
                        <Link to="/" className="link-button" style={{display: "inline-block"}}>
                            Back to Home
                        </Link>
                    </div>
                )}
            </Section>
        );
    }
}

export default ForgotPassword;